import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import template from './gamesEdit.jade';
import Services from '../../services/services';

export class GamesEditController {
  /* @ngInject */
  constructor($stateParams,GamesResource,currentUser,newGame,$state,notify,$auth,Upload) {
    this.GamesResource = GamesResource;
    this.newGame = newGame;
    this.$state = $state;
    this.$auth = $auth;
    this.Upload = Upload;
    this.notify = notify;
    this.isResourceBeingPersisted = false;

    if ($stateParams.id) {
      this.getResource($stateParams.id);
    } else {
      this.new = true;
      this.resource = {
        context: 'other',
        platforms: [],
        rank_as_buyer: 0.3,
        rank_as_seller: 1
      };

      currentUser.subscribe((user) => {
        if(user) {
          this.resource.game_developer_id = !_.isEmpty(user.game_developer_ids) ? user.game_developer_ids[0] : null;
        }
      });
    }
  }

  getResource(id) {
    this.GamesResource.one(id).get().then((res) => {
      this.resource = res;
    });
  }

  save() {
    this.isResourceBeingPersisted = true;
    if (this.resource.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.GamesResource.post(this.resource)
      .then((res) => {
        this.checkAndUploadLogoFile(res.id);
        this.newGame.onNext(res);
        this.notify.created('app', res.name);
        this.$state.go("app.analytics.index", {gameId: res.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  update() {
    this.resource.save()
      .then(() => {
        this.checkAndUploadLogoFile(this.resource.id);
        this.notify.updated('app', this.resource.name);
        this.$state.go("app.analytics.index", {gameId: this.resource.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  checkAndUploadLogoFile(gameId) {
    if (this.logo) {
      this.Upload.upload({
        url: `/api/v1/games/${gameId}/logo_upload`,
        headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
        data: {file: this.logo}
      }).then((res) => {
        this.resource.url = res.data.url;
        this.logo = null;
      })
    }
  }
}

export function GamesEditComponent() {
  return {
    template,
    controller: GamesEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.games.edit', [
  'ngFileUpload',
  ConfigsModule.name,
  ResourcesModule.name,
  ServicesModule.name,
  Services.name
])
.directive('gamesEdit', GamesEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/gamesEdit.js
 **/